 <div class="login-content">
   <h2>Sign up</h2>
   <p class="text-medium mt-1">Create Social Auditor account</p>
   <div>
     <div class="text-center my-3">
       <app-signup-google></app-signup-google>
       <br>
       <app-signup-fb></app-signup-fb>
     </div>
     <p class="text-light text-center my-2">- OR -</p>
     <form [formGroup]="userForm" (ngSubmit)="onSubmit()" class="login-forms">
       <div class="form-group text-group mb-3">
         <label>E-mail</label>
         <input formControlName="email" class="form-control" type="text" placeholder="E-mail address...">
       </div>
       <div class="form-group text-group mb-3">
         <label>Password</label>
         <input formControlName="password" class="form-control" type="password" placeholder="Password...">
         <div
           class="mt-3"
           *ngIf="userForm.controls.password.dirty && userForm.controls.password.errors !== null"
         >
           <div class="text-red mt-2" role="alert">Incorrect password</div>
         </div>
       </div>
       <div class="form-group text-group">
         <label>Retype password</label>
         <input formControlName="retyped_password" class="form-control" type="password" placeholder="Retype password...">
         <div class="mt-3" *ngIf="userForm.controls.retyped_password.dirty && userForm.controls.password.dirty && userForm.errors !== null && userForm.errors.matchFields">
           <div class="text-red" role="alert">Passwords do not match. Please try again</div>
         </div>
       </div>
       <div class="my-4 text-center">
         <button class="btn btn-blue btn-lg"
                 type="submit" [disabled]="!userForm.valid"
         >Create account</button>
       </div>
       <p class="text-light">By clicking the "Create account" button you agree to our Terms of use and Privacy Policy.</p>
     </form>
   </div>
 </div>

